import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AlertTriangleIcon, SmartphoneIcon, UsersIcon } from 'lucide-react';
export function Problem() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const problems = [{
    icon: UsersIcon,
    text: "En la escuela, el miedo a ser 'excluido' los obliga a imitar conductas peligrosas (vaping, desafíos absurdos, rebeldía injustificada)."
  }, {
    icon: SmartphoneIcon,
    text: "En el teléfono, la presión por 'encajar' es una tortura de 24 horas al día."
  }];
  return <section ref={ref} className="w-full bg-dark-navy py-16 md:py-20 px-6" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-80">
          <div className="flex items-center gap-3 mb-8" data-id="element-81">
            <AlertTriangleIcon className="w-8 h-8 text-gold" data-id="element-82" />
            <h2 className="text-3xl md:text-4xl font-oswald text-gold" data-id="element-83">
              El Problema Real
            </h2>
          </div>

          <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-84">
            Criar a un adolescente en Estados Unidos es pelear una batalla en
            dos frentes:
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-85">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-darker-navy p-6 rounded-lg border-l-4 border-cyan" data-id="element-86">
                <problem.icon className="w-10 h-10 text-cyan mb-4" data-id="element-87" />
                <p className="text-gray-300 leading-relaxed" data-id="element-88">{problem.text}</p>
              </motion.div>)}
          </div>

          <div className="bg-gradient-to-r from-gold/10 to-cyan/10 p-8 rounded-lg border border-gold/30" data-id="element-89">
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-90">
              Como padres latinos, nuestra reacción natural es prohibir,
              castigar o recordarles cómo eran las cosas "en nuestro país". Pero
              en el contexto de USA,{' '}
              <span className="text-gold font-bold" data-id="element-91">
                eso solo logra que nos oculten la verdad, que nos mientan mejor
                y que confíen más en los extraños que en su propia familia.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}